import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { SectionBadge } from '../SectionBadge';
import { Reveal } from '../Reveal';
import { BEFORE_AFTER } from '../../data/content';
export function BeforeAfter() {
  return;
}